@import "@zvuk-b2b/react-uikit/ui/styles/_variables";
@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

.TopBanner {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: all $transition-duration-s;

    &[data-type=GRACE] {
        background: $color-warning-500;
        
        & > div {
            color: $color-neutral-700;
        }
    }

    &[data-type=UNPAID] {
        background: $color-danger-600;
    }

    &[data-type=TRIAL] {
        background: $color-black;
    }

    &[data-type=PAYMENT] {
        background: #F19D02;
    }

    @include media-mobile {
        flex-direction: column;
        justify-content: flex-end;
        padding: $ceil * 2;
    }

    @include media-desktop {
        flex-direction: row;
        justify-content: center;
        padding: $ceil * 2 $ceil * 8;
    }

    &Button {
        padding: 0 $ceil * 2;
        font-weight: $font-weight-medium;
        font-size: $font-size-14;
        line-height: $line-height-20;
        min-height: 32px;
        background: rgba(255, 255, 255, 20%);
        backdrop-filter: blur(4px);
        border-radius: $border-radius-16;
        width: fit-content;
        white-space: nowrap;

        @include media-mobile {
            width: 100%;
            margin-top: $ceil * 2;
        }

        @include media-desktop {
            margin-left: $ceil * 2;
        }
    }

    &ButtonTrialWrapper {
        width: 234px;
        position: relative;
    }

    &ButtonTrialImage {
        position: absolute;
        // values relate with image
        left: 16px;
        top: -140px;
    }

    &Description {
        font-weight: $font-weight-medium;
        font-size: $font-size-14;
        line-height: $line-height-20;
        color: $color-white;
        text-wrap-style: balance;

        @include media-mobile {
            max-width: 90%;
            line-height: $line-height-24;
        }

        @include media-desktop {
            max-width: 100%;
        }

        &Days {
            background-color: $color-white;
            border-radius: $border-radius-16;
            display: inline;
            color: $color-black;
            padding: $ceil * 0.25 $ceil * 0.5;
        }
    }

    mark {
        background: none;
        color: $color-warning-500;

        &[data-percent=true] {
            font-weight: $font-weight-bold;
            color: #72C3FD;
        }
    }

    &CloseButton {
        position: absolute;
        stroke: $color-white;
        background: rgba(255, 255, 255, 20%);
        backdrop-filter: blur(4px);
        border-radius: $border-radius-24;
        padding: 4px;

        @include media-mobile {
            width: 24px;
            height: 24px;
            right: $ceil;
            top: $ceil;
        }

        @include media-desktop {
            width: 32px;
            height: 32px;
            right: $ceil * 3;
        }

        &Icon {
            @include media-mobile {
                width: 16px;
                height: 16px;
            }
        }
    }

    &PaymentSchemeCalendar {
        display: block;
        margin-right: $ceil * 2;
        width: 45px;
        height: 40px;
    }

    &LeftText {
        text-align: left;
    }
}
